import React from 'react';

const Drinks = () => {
  return (
    <div className="min-h-screen pt-20 bg-gray-300 relative" style={{
      backgroundImage: `
        linear-gradient(rgba(128, 128, 128, 0.7), rgba(128, 128, 128, 0.7)),
        url("/images/backgrounds/dining-bg.webp"),
        url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
      `,
      backgroundSize: 'cover, cover, 60px 60px',
      backgroundPosition: 'center, center, 0 0',
      backgroundRepeat: 'no-repeat, no-repeat, repeat',
      filter: 'grayscale(0.3)'
    }}>
      {/* Header Section */}
      <div className="pt-20 relative">
        <h1 className="text-[3.25rem] leading-none font-medium pt-24 text-center uppercase my-3 mx-0 mb-3 text-black">
          Our Drinks
        </h1>
      </div>

      {/* Drinks Content */}
      <div className="pb-10 px-4 pt-3 m-auto max-w-7xl">
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">

          {/* Beverages Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Beverages</h2>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <h3 className="font-bold text-yellow-800">Fountain Drinks</h3>
                <p className="text-sm text-gray-700">Coke, Diet Coke, Coke Zero, Sprite, Dr. Pepper, Pink Lemonade, Barq’s Root Beer</p>
              </div>

              <div className="pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Red Bull</h3>
                </div>
                <ul className="text-sm text-gray-700 list-disc pl-5">
                  <li>Red Bull Energy Drink</li>
                  <li>Red Bull Sugarfree</li>
                  <li>Red Bull Red Edition Sugarfree (Watermelon)</li>
                  <li>Red Bull Red Edition (Watermelon)</li>
                  <li>Red Bull White Edition (Coconut)</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Draft Beer Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Draft Beer</h2>
            <div className="space-y-2">
              <p className="text-gray-700">Bud Light</p>
              <p className="text-gray-700">Miller Lite</p>
              <p className="text-gray-700">Coors Light</p>
              <p className="text-gray-700">Michelob Ultra</p>
              <p className="text-gray-700">Yuengling</p>
              <p className="text-gray-700">Blue Moon</p>
              <p className="text-gray-700">Stella Artois</p>
              <p className="text-gray-700">Guinness</p>
              <p className="text-gray-700">Angry Orchard</p>
              <p className="text-gray-700">Voodoo Ranger Juicy Haze</p>
              <p className="text-gray-700">Fat Tire</p>
              <p className="text-gray-700">Sam Adams Seasonal</p>
            </div>
          </div>

          {/* Bottles & Cans Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Bottles & Cans</h2>
            <div className="space-y-2">
              <p className="text-gray-700">Budweiser</p>
              <p className="text-gray-700">Bud Light</p>
              <p className="text-gray-700">Miller Lite</p>
              <p className="text-gray-700">Coors Light</p>
              <p className="text-gray-700">Michelob Ultra</p>
              <p className="text-gray-700">Corona</p>
              <p className="text-gray-700">Corona Light</p>
              <p className="text-gray-700">Heineken</p>
              <p className="text-gray-700">Heineken 0.0</p>
              <p className="text-gray-700">Modelo</p>
              <p className="text-gray-700">PBR</p>
              <p className="text-gray-700">Busch Light</p>
              <p className="text-gray-700">Rolling Rock</p>
              <p className="text-gray-700">Smirnoff Ice</p>
              <p className="text-gray-700">Twisted Tea</p>
            </div>
          </div>

          {/* Wine Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Wine</h2>
            <div className="space-y-2">
              <p className="text-gray-700">Chardonnay</p>
              <p className="text-gray-700">Pinot Grigio</p>
              <p className="text-gray-700">Moscato</p>
              <p className="text-gray-700">White Zinfandel</p>
              <p className="text-gray-700">Merlot</p>
              <p className="text-gray-700">Cabernet</p>
              <p className="text-gray-700">Pinot Noir</p>
            </div>
          </div>

        </div>
      </div>

      {/* Responsible Drinking Notice */}
      <div className="pb-16 text-center">
        <div className="max-w-lg mx-auto bg-white rounded-lg shadow-lg p-8 mb-10">
          <h2 className="text-2xl font-bold mb-4">Drink Responsibly</h2>
          <p className="mb-2 text-gray-700">
            Please enjoy our drinks responsibly. We offer non-alcoholic options for designated drivers.
          </p>
          <p className="text-sm text-gray-600">
            Must be 21+ to consume alcohol. Valid ID required.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Drinks;
